import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { useLocalizedPath } from '../../i18n/useLocalizedPath';

interface AuthorBioProps {
  /** Nome do autor — default "Ivan Henrique". */
  name?: string;
}

export function AuthorBio({ name = 'Ivan Henrique' }: AuthorBioProps) {
  const { t } = useTranslation('blog');
  const path = useLocalizedPath();

  return (
    <aside className="mt-12 bg-gray-50 border border-gray-200 rounded-2xl p-6 max-w-3xl mx-auto">
      <div className="flex items-start gap-4">
        <div className="w-14 h-14 rounded-full bg-gradient-to-br from-primary-500 to-primary-700 flex items-center justify-center text-white text-xl font-bold flex-shrink-0">
          {name.split(' ').map(n => n[0]).slice(0, 2).join('')}
        </div>
        <div>
          <p className="text-xs text-gray-500 uppercase tracking-widest font-semibold">
            {t('author.eyebrow', 'Sobre o autor')}
          </p>
          <h3 className="mt-1 text-base font-bold text-gray-900">{name}</h3>
          <p className="mt-2 text-sm text-gray-600 leading-relaxed">
            <Trans
              i18nKey="author.bio"
              ns="blog"
              defaults="Fundador do Bolão Elite, Engenheiro de Software e fã de futebol. Escreve sobre campeonatos, estratégia de palpites e tudo o que acontece nas quatro linhas — sempre com foco em quem quer jogar bolão com os amigos sem complicação. <1>Conheça a história do Bolão Elite</1>."
              components={[
                <span key="0" />,
                <Link
                  key="1"
                  to={path('sobre')}
                  className="text-primary-600 font-semibold hover:underline"
                />,
              ]}
            />
          </p>
        </div>
      </div>
    </aside>
  );
}

export default AuthorBio;
